import validation, { type SerializedError as SE } from "@subly/s1/core/validation";

export type SerializedError = SE;

export default { ...validation };